import { Browser } from "./browser";
export var Keyboard;
(function (Keyboard) {
    Keyboard.isControlKey = ({ ctrlKey, metaKey }) => Browser.isMacOS() ? metaKey : ctrlKey;
    Keyboard.isDelete = (event) => event.code === "Delete" || event.code === "Backspace";
    Keyboard.isSelectAll = (event) => Keyboard.isControlKey(event) && !event.shiftKey && event.code === "KeyA";
    Keyboard.isDeselectAll = (event) => Keyboard.isControlKey(event) && event.shiftKey && event.code === "KeyA";
})(Keyboard || (Keyboard = {}));
